/*
 * Model for handling campaign launch
 */

define(["backbone", "messaging/messenger", "configuration/properties"], function (
  Backbone,
  Messenger,
  Properties,
) {
  "use strict";

  const CampaignLaunchModel = {};

  CampaignLaunchModel.campaignSchedule = Backbone.Model.extend(
    {
      defaults: {
        stateId: 0,
        userId: 0,
      },
    },
    { VERY_OLD_TIMESTAMP: "1970-01-01T00:00:00Z" },
  );

  CampaignLaunchModel.campaignLaunch = CampaignLaunchModel.campaignSchedule.extend({
    url: function () {
      const kbId = Messenger.reqres.request("active:kb");
      return `${Properties.adminRootURL}/kbs/${kbId}/campaigns/${this.get("campaignId")}/launch`;
    },
  });

  CampaignLaunchModel.campaignScheduleList = Backbone.Collection.extend({
    model: CampaignLaunchModel.campaignSchedule,
    addCampaignSchedule: function (attributes) {
      const campaignSchedule = new CampaignLaunchModel.campaignSchedule();
      campaignSchedule.set(attributes);
      this.add(campaignSchedule);
      return campaignSchedule;
    },
    createNewCampaignSchedule: function (attributes) {
      return new CampaignLaunchModel.campaignSchedule(attributes);
    },
  });

  return CampaignLaunchModel;
});
